<template>
  <!-- 最外层wrap div  start-->
  <div class="wrap_Box">
    <!-- 里面版心 box start -->
    <div class="innerBox">
      <!-- 个人信息 start -->
      <div class="my_info">
        <!-- 个人信息上面部分 start -->
        <div class="my_info_top flex" @click="handleToReal">
          <!-- 个人信息上面部分 >左边 图片区域 start -->
          <div class="my_info_top_left">
            <img :src="userInfo.headImgUrl" alt />
          </div>
          <!-- 个人信息上面部分 >左边 end -->
          <!-- 个人信息上面部分 >右边 start -->
          <div class="my_info_top_right flex-1">
            <div class="my_info_top_right_top">
              <span>{{userInfo.nickName}}</span>			  
			  <img :src="userInfo.userTypeIcon" v-if="userInfo.userTypeIcon"/>
			  <span class="memberType" v-else>{{userInfo.userTypeName}}</span>
            </div>
            <div
              class="my_info_top_right_bottom"
            >{{userInfo.memberInfo&&userInfo.memberInfo.memberPhone||'未绑定'}}</div>
            <!-- 箭头 -->
            <div class="right-row" v-show="!(this.userInfo && this.userInfo.memberInfo)">
              <img src="../assets/image/my/more2.png" alt />
            </div>
          </div>
          <!-- 个人信息上面部分 >右边 end -->
        </div>
        <!-- 个人信息上面部分 end -->
      </div>
	  
	  <div class="myServe" v-if="serviceList.vipService">
	    <!-- 我的服务>上面标题部分 start -->
	    <div class="myServe_title">
	      <div class="titleContianer flex">
	        <div class="left_img">
	          <a href>
	            <img src="../assets/image/my/member_card_vip.png" alt />
	          </a>
	        </div>
	        <div class="right_txt">
	          <span>Vip尊享服务</span>
	        </div>
	      </div>
	    </div>
	    <div class="myServe_info flex flex-wrap">	      	     
	      <div class="myServe_info_item" v-for="(item,index) in serviceList.vipService" :key="index">
	        <div class="container_item">
	          <a
	            :href="item.linksUrl"
	            class="link-a"	@click="addClickData(item)">
	            <!-- 图片box -->
	            <div class="myServe_info_item_img_vip">
	              <img :src="item.imgUrl" alt />
	            </div>
	            <!-- 文字box -->
	            <div class="myServe_info_item_txt">
	              <span>{{item.itemName}}</span>
	            </div>
				<div class="myServe_info_item_num">
				  <span>共{{item.serviceNum}}次，剩余{{item.amount}}次</span>
				</div>
	          </a>
	        </div>
	      </div>	  		 	 
	    </div>
	    <!-- 我的服务>下面信息部分  end -->
	  </div>
	  
      <!-- 我的服务 start -->
      <div class="myServe">
        <!-- 我的服务>上面标题部分 start -->
        <div class="myServe_title">
          <div class="titleContianer flex">
            <div class="left_img">
              <a href>
                <img src="../assets/image/my/MyServe.png" alt />
              </a>
            </div>
            <div class="right_txt">
              <span>服务使用记录</span>
            </div>
          </div>
        </div>
        <!-- 我的服务>上面标题部分 end -->
        <!-- 我的服务>下面信息部分  start -->
        <div class="myServe_info flex flex-wrap">
          <!-- 我的服务>下面信息部分 子部分  start -->
          <!-- 第一条 -->
          <div class="myServe_info_item" v-for="(item,index) in serviceList.myService" :key="index">
            <div class="container_item">
              <a
                :href="item.needRealName==1?'javascript:;':item.linksUrl"
                class="link-a"
                @click="handleToRealName(item)"
              >
                <!-- 图片box -->
                <div class="myServe_info_item_img">
                  <img :src="item.imgUrl" alt />
                </div>
                <!-- 文字box -->
                <div class="myServe_info_item_txt">
                  <span>{{item.itemName}}</span>
                </div>
              </a>
            </div>
          </div>
		  <div class="myServe_info_item">
		    <div class="container_item" @click="handleLink('patient')">		      
		        <!-- 图片box -->
		        <div class="myServe_info_item_img">
		          <img src="../assets/image/my/CommonVisitors.png" alt />
		        </div>
		        <!-- 文字box -->
		        <div class="myServe_info_item_txt">
		          <span>常用就诊人</span>
		        </div>
		    </div>
		  </div>
		  <div class="myServe_info_item">
		    <div class="container_item" @click="handleToRealNameActiveCard(serviceList.newCard)">		      
		        <!-- 图片box -->
		        <div class="myServe_info_item_img">
		          <img src="../assets/image/my/ActivationCardTicket.png" alt />
		        </div>
		        <!-- 文字box -->
		        <div class="myServe_info_item_txt">
		          激活卡券
		        </div>
		    </div>
		  </div>
          <!-- 我的服务>下面信息部分 子部分  end -->
        </div>
        <!-- 我的服务>下面信息部分  end -->
      </div>
      <!-- 我的服务 end -->
	<div class="myServe">
	  <!-- 我的服务>上面标题部分 start -->
	  <div class="myServe_title">
	    <div class="titleContianer flex">
	      <div class="left_img">
	        <a href>
	          <img src="../assets/image/my/life-smart.png" alt />
	        </a>
	      </div>
	      <div class="right_txt">
	        <span>智能健康档案</span>
	      </div>
	    </div>
	  </div>
	  <!-- 我的服务>上面标题部分 end -->
	  <!-- 我的服务>下面信息部分  start -->
	  <div class="myServe_info flex flex-wrap">
			  <div class="myServe_info_item">
			    <div class="container_item" @click="handleLink('archives')">		      
			        <!-- 图片box -->
			        <div class="myServe_info_item_img">
			          <img src="../assets/image/my/HealthRecords.png" alt />
			        </div>
			        <!-- 文字box -->
			        <div class="myServe_info_item_txt">
			          <span>我的基础<br/>健康档案</span>
			        </div>
			    </div>
			  </div>
			 <div class="myServe_info_item">
			   <div class="container_item" @click="handleLink('resultList')">		      
			       <!-- 图片box -->
			       <div class="myServe_info_item_img">
			         <img src="../assets/image/my/Physical_Examination_Report.png" alt />
			       </div>
			       <!-- 文字box -->
			       <div class="myServe_info_item_txt">
			         <span>我的中医<br/>体检档案</span>
			       </div>
			   </div>
			 </div>
				 <div class="myServe_info_item">
				   <div class="container_item" @click="xiyi">		      
				       <!-- 图片box -->
				       <div class="myServe_info_item_img">
				         <img src="../assets/image/my/xiyi.png" alt />
				       </div>
				       <!-- 文字box -->
				       <div class="myServe_info_item_txt">
				         <span>我的西医<br/>体检档案</span>
				       </div>
				   </div>
				 </div>
	    
	  </div>
	  <!-- 我的服务>下面信息部分  end -->
	</div>
	<!-- 个人信息 end -->

      <!-- 我的卡卷和 中医体检报告部分 底部部分 start  -->
      <div class="bottomLink" v-if="serviceList.cardList">
        <!-- 我的卡卷 start  -->
        <div class="my_cardroll bottomLink_item container">
          <a
            class="MycardrollLink"
            @click="handleToRealNameMyCard(serviceList.cardList)"
          >
            <div class="my_cardroll_Contianer comm_Contianer flex">
              <!-- 图片 -->
              <div class="left_img">
                <img src="../assets/image/my/My_card_ticket.png" alt />
              </div>
              <!-- 文字 -->
              <div class="right_txt">
                <span>我的卡券</span>
              </div>
              <!-- 箭头 -->
              <div class="arrowImg">
                <img src="../assets/image/my/more03.png" alt />
              </div>
            </div>
          </a>
        </div>
        <!-- 我的卡卷 end  -->
        <!-- 中医健康体检 start 
        <div
          class="chineseMedicine_healthy bottomLink_item container"
          @click="handleLink('resultList')"
        >
          <div class="my_cardroll_Contianer comm_Contianer flex">
            
            <div class="left_img">
              <img src="../assets/image/my/Physical_Examination_Report .png" alt />
            </div>
            
            <div class="right_txt">
              <span>中医体检报告</span>
            </div>
            
            <div class="arrowImg">
              <img src="../assets/image/my/more03.png" alt />
            </div>
          </div>
        </div>
		-->
        <!-- 中医健康体检 end -->
      </div>
      <!-- 我的卡卷和 中医体检报告部分 底部部分 end  -->
    </div>
    <!-- 里面版心 box start -->
    <alert-box-item :paramObj="paramObj" @handle-cert="handleCert"></alert-box-item>
  </div>
  <!-- 最外层wrap div  end-->
</template>
<script>
import AlertBox from '../components/alert-box'
import { getApi } from '../api/index.js'
import {AppIdName,TokenName,jxAppId} from '../api/api.js';

export default {
  components: {
    'alert-box-item': AlertBox
  },
  data() {
    return {
      userInfo: {},
      serviceList: {},
      paramObj: {},
      lifeToken: ''
    }
  },
  created() {
	let appId = localStorage.getItem(AppIdName);
	this.lifeToken = localStorage.getItem(TokenName+appId || "");	
    if (this.lifeToken) {
      this.getUserInfo()
      this.getServiceList()
    } else {
		if (appId == jxAppId){
		  this.$router.push({
		    path: '/login',
		    query: {
		      isFrom: 2
		    }
		  })
		}else{
			this.handleWx()
		}      
    }
  },
  methods: {
    handleCert() {
      this.$router.push({
        path: '/real',
        query: {
          isFrom: 2
        }
      })
    },
	xiyi(){
		this.$router.push({
		  path: '/xiyi',
		  query: {}
		})
	},
    handleToReal() {
      if (!(this.userInfo && this.userInfo.memberInfo)) {
        this.paramObj = {
          isShow: true,
          title: '提示',
          content: '您还没有实名认证，现在就去完成实名认证。'
        }
      }
    },
	addClickData(item) {
	  getApi({ url: "/home/viewItem/" + item.itemName, query: {} })
	    .then(res => {})
	    .catch(res => {});	  
	},
   handleToRealName(item) {
      if (item.needRealName == 1) {
        this.paramObj = {
          isShow: true,
          title: '提示',
          content: '您还没有实名认证，现在就去完成实名认证。'
        }
      }
    },
    // 激活卡卷
handleToRealNameActiveCard(item){
	/*
	if (item.needRealName == 1) {
       return this.paramObj = {
          isShow: true,
          title: '提示',
          content: '您还没有实名认证，现在就去完成实名认证。'
        }
      }
    */
    this.$router.push('/system/activate')
      
},
//我的卡卷
    handleToRealNameMyCard(item){
		/*
	if (item.needRealName == 1) {
       return this.paramObj = {
          isShow: true,
          title: '提示',
          content: '您还没有实名认证，现在就去完成实名认证。'
        }
      }*/
     this.$router.push('/system/voucher')
    },
    handleWx() {
      let code = this.$route.query.code
      if (code && code != '') {
        this.code = code
        this.toLogin()
      } else {
        this.onCheck()
      }
    },
    toLogin() {
	  let appid = this.$route.query.appid || 'wx5e9898e74f3d23ae'
      getApi({ url: '/member/login/' + this.code+"?appId="+appid, query: {} })
        .then(res => {
          if (res && res.resCode == '0') {
            if (res.data) {
              sessionStorage.setItem('lifejk_token', res.data.accessToken)
              this.getUserInfo()
              this.getServiceList()
            } else {
              this.$toast('登录失败')
            }
          } else {
            this.$toast(res.resMsg || '登录失败')
          }
        })
        .catch(res => {
          console.log('登录失败')
        })
    },
    onCheck() {
      let url = encodeURIComponent(window.location.href)
      let appid = this.$route.query.appid || 'wx5e9898e74f3d23ae'
      let weixinUrl =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        url +
        '&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
      window.location.href = weixinUrl
    },
    getUserInfo() {
      getApi({ url: '/member/getSourceInfo', query: {} })
        .then(res => {
          if (res && res.resCode == '0') {
            if (res.data) {
              this.userInfo = res.data
            }
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    handleLink(name) {
      if (name === 'archives') {
        this.$router.push({
          path: '/archives'
        })
      } else if (name === 'patient') {
        this.$router.push({
          path: '/patientInfo/list'
        })
      } else if (name === 'resultList') {
        this.$router.push({
          path: 'medical/resultList'
        })
      }
    },
    getServiceList() {
      getApi({ url: '/my/serviceList', query: {} })
        .then(res => {
          if (res && res.resCode == '0') {
            if (res.data) {
              this.serviceList = res.data
              //console.log(this.serviceList)
            }
          }
        })
        .catch(res => {
          console.log(res)
        })
    }
  }
}
</script>
 <style lang="less" scoped>
@import '../common/css/style.css';
/* 最外层div */
.wrap_Box {
  width: 100%;
  //里层 版心box
  .innerBox {
    width: 100%;
  }
}
.link-a {
  width: 100%;
  height: 100%;
}
// 个人信息
.my_info {
  background-color:#EEEEEE;
  width: 100%;
}
// 个人信息 上面部分
.my_info_top {
  padding: 0.3rem 0.32rem 0.4rem;
  background-color: #FFFFFF;
  box-sizing: border-box;
  //个人信息 顶部部分> 左边
  .my_info_top_left {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
    .left_imgBox {
      overflow: hidden;
      text-align: center;
      line-height: 1.6rem;
      border-radius: 50%;
      width: 1.6rem;
      height: 1.6rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  //个人信息 顶部部分> 右边
  .my_info_top_right {
    box-sizing: border-box;
    width: 100%;
    position: relative;
    margin-left: 0.3rem;
    height: 100%;
    padding-top: 0.3rem;
    min-height: 1.6rem;
    box-sizing: border-box;
    // 箭头右边
    .right-row {
      position: absolute;
      left: 4.6rem;
      top: 50%;
      transform: translateY(-50%);
    }
    .my_info_top_right_top {
      letter-spacing: -0.008rem;
      font-size: 0.34rem;
      color: rgb(51, 51, 51);
	  line-height:0.34rem;
	  .memberType{
		  margin-left: 0.3rem;
		  background-color:#999999;
		  color: white;
		  font-size: 0.2rem;
		  padding: 0.02rem 0.2rem;
		  border-radius: 0.5rem;
	  }
	  img{
		  width: 1rem;
		  height: 0.4rem;
		  margin-left: 0.2rem;
	  }
    }
    .my_info_top_right_bottom {
      letter-spacing: -0.007rem;
      margin-top: 0.2rem;
      font-size: 0.3rem;
      color: rgb(51, 51, 51);
    }
  }
}
// 个人信息 下面部分
.my_info_bottom {
  background-color: #FFFFFF;
  height: 0.92rem;
  border-top: 0.01rem solid rgb(220, 224, 225);
  border-bottom: 0.01rem solid rgb(220, 224, 225);
  width: 100%;
}
// 个人信息 下面部分 子部分
.my_info_bottom_item {
  width: 33.33%;
  border-right: 0.01rem solid rgb(220, 224, 225);
  .activeCardRoll {
    width: 100%;
    height: 100%;
  }
  // 个人信息 下面部分 子部分 容器
  .container_item {
    // width: rem;
    // height: 0.3rem;
    width: 100%;
    margin-top: 0.15rem;
    margin-bottom: 0.33rem;
    color: rgb(51, 51, 51);
  }
  // 个人信息 下面部分 子部分 左边
  .container_item_left {
    padding-left: 0.27rem;
    height: 100%;
    width: 0.3rem;
    height: 0.3rem;

    img {
      display: block;
      margin-top: 0.2rem;	  
      width: 100%;
      height: 100%;
    }
  }
  // 个人信息 下面部分 子部分 右边
  .container_item_right {
    margin-left: 0.2rem;
    line-height: 0.34rem;
    height: 100%;
	width: 1.2rem;
    font-size: 0.26rem;
    text-align: left;
  }
}
// 我的服务
.myServe {
  background-color: #ffffff;
  margin-top: 0.16rem;
  width: 100%;
  // border-top: 0.01rem solid #aeaeae;
  // border-bottom: 0.01rem solid #aeaeae;
  
}

// 我的服务 标题部分 上面
.myServe_title {
  width: 100%;
  height: 0.95rem;
  background-color: #FFFFFF;
  overflow: hidden;
  //我的服务 标题部分 上面 容器部分
  .titleContianer {
    height: 0.33rem;
    margin-left: 0.32rem;
    margin-top: 0.32rem;
    margin-bottom: 0.32rem;
    // 图片 box 部分
    .left_img {
      width: 0.3rem;
      height: 0.33rem;
      // background-color: red;
      img {
        width: 100%;
        height: 100%;
        display: block;
        margin: 0 auto;
      }
    }
    // 右边 文字部分
    .right_txt {
      margin-left: 0.1rem;
      text-align: center;
      line-height: 0.33rem;
      font-size: 0.26rem;
      color: rgb(51, 51, 51);
    }
  }
}
// 我的服务>下面信息部分
.myServe_info {
  border-top: 0.01rem solid rgb(220, 224, 225);
  border-bottom: 0.01rem solid rgb(220, 224, 225);
  padding: 0.1rem 0rem;
  width: 100%;
  overflow: hidden;
  // 我的服务>下面信息部分 子部分
  .myServe_info_item {
    width: 33.33%;
    overflow: hidden;
    padding: 0.2rem 0rem;
    // 容器部分
    .container_item {
      width: 100%;
      height: 100%;
      // 图片div
      .myServe_info_item_img {
        margin: 0 auto;
        width: 0.4rem;
        height: 0.4rem;
        img {
          width: 100%;
          height: 100%;
          display: inline-block;
        }		
      }
	  .myServe_info_item_img_vip {
	    margin: 0 auto;
	    width: 0.6rem;
	    height: 0.6rem;
	    img {
	      width: 100%;
	      height: 100%;
	      display: inline-block;
	    }
	  }
      //  文字div
      .myServe_info_item_txt {
        text-align: center;
        margin-top: 0.15rem;
        font-size: 0.26rem;		
        letter-spacing: -0.007rem;
        color: rgb(51, 51, 51);
      }
	  .myServe_info_item_num{
		  text-align: center;
		  margin-top: 0.15rem;
		  font-size: 0.24rem;		
		  letter-spacing: -0.007rem;
		  color: #666666;
	  }
    }
  }
}
// 底部 我的卡卷和 中医体检报告 部分
.bottomLink {
  overflow: hidden;
  width: 100%;
  margin-top: 0.2rem;
  // 我的卡卷
  .my_cardroll {
    width: 100%;
    height: 0.95rem;

    .MycardrollLink {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  // 中医体检报告
  .chineseMedicine_healthy {
    margin-top: 0.16rem;
    height: 0.95rem;
  }
  .bottomLink_item {
    overflow: hidden;
    background-color: #ffffff;
    height: 0.95rem;
    width: 100%;
    //我的服务 标题部分 上面 容器部分
    .comm_Contianer {
      height: 0.5rem;
      // height: 100%;
      position: relative;
      margin-left: 0.2rem;
      margin-top: 0.34rem;
      margin-bottom: 0.34rem;

      // 图片 box 部分
      .left_img {
        width: 0.32rem;
        height: 0.32rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
      // 右边 文字部分
      .right_txt {
        letter-spacing: -0.007rem;
        margin-left: 0.15rem;
        text-align: center;
        line-height: 0.35rem;
        font-size: 0.28rem;
        color: rgb(51, 51, 51);
      }
      .arrowImg {
        position: absolute;
        top: -0.1rem;
        left: 6.67rem;
      }
    }
  }
}
</style>

